import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { jobService } from '../services/jobService';
import { format } from 'date-fns';

export const useJobDetails = () => {
    const { id } = useParams();

    const {
        data: job,
        isLoading,
        error,
        refetch,
    } = useQuery({
        queryKey: ['jobDetails', id],
        queryFn: () => jobService.getJobById(id).then(res => res.data.data),
        staleTime: 1000 * 60 * 5,
        enabled: !!id,
    });

    const formattedJob = job ? {
        id: job.id,
        jobNumber: job.job_number,
        totalVisits: job.total_visits,
        startDate: job.start_date ? format(new Date(job.start_date), 'MMM d, yyyy') : '—',
        startTime: job.start_time?.slice(0, 5) || '—',
        endTime: job.end_time?.slice(0, 5) || '—',
        repeats: job.repeats,
        visitInstructions: job.visit_instructions || 'No instructions provided',
        internalNotes: job.notes || '',

        clientName: `${job.quote.first_name} ${job.quote.last_name}`.trim(),
        clientEmail: job.quote.email,
        clientPhone: job.quote.phone,

        boatType: job.quote.boat_type || '—',
        boatYear: job.quote.boat_year || '—',
        boatMake: job.quote.boat_make || '—',
        boatLength: job.quote.boat_length || '—',
        boatLocation: job.location || job.quote.boat_location || '—',
        zipCode: job.quote.zip_code || '—',
        isBoatInWater: job.is_boat_in_water,
        dock: job.dock,
        slipNumber: job.slip_number,
        customFields: job.custom_fields || {},

        surveyors: job.surveyors?.map(s => ({
            name: s.full_name,
            email: s.email,
            phone: s.phone,
            amount: parseFloat(s.pivot.amount) || 0,
        })) || [],

        raw: job,
    } : null;

    return {
        job: formattedJob,
        isLoading,
        error,
        refetch,
    };
};